export enum AdmissionReportPage {
    NewAdmission = 1,
    AdmissionStation = 2,
    HospitalRooms = 3,
    PatientRegistration = 4,
}
